import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';
import { Divider } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      borderRadius: '0.5rem',
      width: '100%',
      maxWidth: '50rem',
      height: 'unset',
    },
  },
}));

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  backgroundColor: theme.palette.primary.main,
  height: '100%',
});

export const Header = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 'rem',
  padding: '1rem',
});

export const CloseIconStyled = styled(CloseIcon)({
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
});

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  padding: '0.2rem',
  flexGrow: 1,

  [theme.breakpoints.up('sm')]: {
    maxHeight: '25.625rem',
  },
});

export const Footer = styled('div')({
  display: 'flex',
  justifyContent: 'end',
  gap: '1rem',
  padding: ' 2.5rem',
  flexDirection: 'column-reverse',
  marginTop: 0,

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '5.5rem',
  },
});

export const AlignFilter = styled('div')({
  marginTop: '3rem',
});

export const FixedElements = styled('div')({
  position: 'sticky',
  top: '-0.188rem',
  zIndex: 10,
  backgroundColor: theme.palette.primary.main,
});

export const DividerStyled = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.details.light,
}));
